import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_CATEGORIES } from 'actions/apiActionConstants'
import getMerchandiseCategories from 'api/merchandise/getMerchandiseCategories'

interface Options {
  categorySlugs?: Array<string>;
  categoryIds?: Array<string>;
}

function fetchMerchandiseCategories(options: Options = {}): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { categorySlugs = [], categoryIds = [] } = options

    const allCategories = Object.values(state.merchandise.merchandiseCategories)
    const missingSlugs = categorySlugs.filter(slug => !allCategories.some(cat => cat.slug === slug))
    const missingIds = categoryIds.filter(id => !state.merchandise.merchandiseCategories[id])
    const fetching = missingSlugs.some(slug => state.merchandise.fetchingMerchandiseCategories[slug])
    const error = missingSlugs.some(slug => state.merchandise.merchandiseCategoryErrors[slug])

    if (
      (!missingSlugs.length && !missingIds.length) ||
      fetching ||
      error) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_CATEGORIES,
      request: () => getMerchandiseCategories({
        categorySlugs: missingSlugs,
        categoryIds: missingIds,
      }),
      keys: [...missingSlugs, ...missingIds],
    })
  }
}

export default fetchMerchandiseCategories
